import styled from 'styled-components'
import theme from 'theme_'
import { Font14 } from 'components/Typography'
import Icon from '@mdi/react'

export const WizardStepsContainer = styled.div`
  display: none;
  gap: 16px;
  justify-content: space-between;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const WizardStepsBlock = styled.div`
  display: flex;
  flex-basis: 100%;
  align-items: center;
  gap: 10px;
  padding: ${theme.spacing.xs} ${theme.spacing.s};
  background: ${theme.colors.white};
  border-radius: 8px;
`

export const WizardStepsTitle = styled.div<{
  selected: boolean
  isGrey: boolean
}>`
  ${Font14};
  line-height: 24px;
  color: ${(p) =>
    p.isGrey ? theme.colors.darkeyGrey : theme.colors.otterWarmBlack};
  font-weight: ${(p) => (p.selected ? '900' : '325')};
`

export const WizardStepsIcon = styled(Icon)`
  width: 20px;
  height: 20px;
`

export const WizardStepsIconSuccess = styled(WizardStepsIcon)`
  color: ${theme.colors.successGreen};
`

export const WizardStepsIconUnselected = styled(WizardStepsIcon)`
  color: ${theme.colors.darkeyGrey};
`

export const WizardStepsIconCurrent = styled(WizardStepsIcon)`
  color: ${theme.colors.horizonOrange};
`

export const WizardStepsErrorWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`
